import { isArray } from 'lodash';

export const stylesForRemove = {
  multiValue: (base, state) => {
    return state.data.isFixed ? { ...base, backgroundColor: 'gray' } : base;
  },
  multiValueLabel: (base, state) => {
    return state.data.isFixed
      ? { ...base, fontWeight: 'bold', color: 'white', paddingRight: 6 }
      : base;
  },
  multiValueRemove: (base, state) => {
    return state.data.isFixed ? { ...base, display: 'none' } : base;
  },

  control: (styles) => ({ ...styles, borderColor: '#e4e7ea' }),
};

export const findValueInOptionsBy = (value, options = [], field = 'value') => {
  return (isArray(options) ? options : []).find((el) => el?.[field] === value) || {};
};
